import { getGaDomain, getHostname } from "./initialize";
import GA from "react-ga";
import { getTrackerNames } from "./utils";

// DOCS: https://www.notion.so/absdigital/f6e2d64589c743da9567e86892f8bc3a

export const trackPage = (page: string, options = {}) => {
  const trackerNames = getTrackerNames();
  GA.set({ page, hostname: getGaDomain(), ...options }, trackerNames);
  GA.pageview(page, trackerNames);
};

const allTrackersEvent = (gaEvent: GA.EventArgs) => {
  GA.event(gaEvent, getTrackerNames());
};

export const trackPwaInstall = () => {
  allTrackersEvent({
    category: "PWA",
    action: "Install",
    label: getHostname()
  });
};

export const trackBibleTextDownload = (bibleId: string) => {
  allTrackersEvent({
    category: "Offline Text",
    action: "Download Text",
    label: bibleId
  });
};

export const trackBibleTextDownloadCancel = (bibleId: string) => {
  allTrackersEvent({
    category: "Offline Text",
    action: "Cancel Text Download",
    label: bibleId
  });
};

export const trackBibleTextDownloadRemoval = (bibleId: string) => {
  allTrackersEvent({
    category: "Offline Text",
    action: "Remove Text",
    label: bibleId
  });
};
